import Drawer from '@mui/material/Drawer';
import { ArrowLeftIcon } from '@heroicons/react/solid';
import { Button } from '../../components/ui';
import { getAttendanceList } from '../../api/attendance';
import { useEffect, useState } from 'react';
import Moment from 'react-moment';
import usePut from '../../hooks/put/usePut';
import toast, { Toaster } from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';
import RedeemLeaveDay from '../../components/sections/salary/RedeemLeaveDay';
import useGet from '../../hooks/read/useGet';



const presentDefinition = {
    'pending': 'bg-yellow-100 text-yellow-700',
    'under process': 'bg-orange-100 text-orange-700',
    'absent': 'bg-red-100 text-red-700',
    'present': 'bg-green-100 text-green-700',
    'half_day': 'bg-fuchsia-100 text-fuchsia-70',
    'weekend': 'bg-blue-100 text-blue-700',
    'approved_leave': 'bg-indigo-200 text-indigo-700',
    'missed_punch': 'bg-purple-200 text-purple-700' 
}

// present
// absent
// half_day
// holiday
// weekend_full_day
// weekend_first_half
// weekend_second_half
// on_approved_leave
const paymentDefinition = [
    {
        value: 'present',
        label: 'Present'
    },
    {
        value: 'pending',
        label: 'Pending'
    },
    {
        value: 'absent',
        label: 'Absent'
    },
    {
        value: 'half_day',
        label: 'Half day'
    },
    {
        value: 'holiday',
        label: 'Holiday'
    },
    {
        value: 'weekend_full_day',
        label: 'Weekend full day'
    },
    {
        value: 'weekend_first_half',
        label: 'Weekend first half'
    },
    {
        value: 'weekend_second_half',
        label: 'Weekend second half'
    },
    {
        value: 'on_approved_leave',
        label: 'On approved leave'
    },
    
    {
        value: 'missed_punch',
        label: 'Missed Punch'
    },

]

const PaymentLog = ({
    open,
    onClose,
    id
}) => {
    let [searchParams, setSearchParams] = useSearchParams();
    let initialData = {
        month_and_year:new Date(searchParams.get('date')) || new Date(),
        company_employee_id: id,
        screen: 'salary'
    }
    const [attendanceList, setAttendanceList] = useState([])
    const [isFetching, setIsFetching] = useState(false)
    const [isDataFound, setDataFound] = useState(true)
    const [calendarData, setCalendarData] = useState([])
    
    useEffect(() => {
        handleCalculateSalary()
    }, [])
    
    const handleCalculateSalary = () => {
        setDataFound(true)
        setIsFetching(true)
        getAttendanceList(initialData)
            .then((res) => {
                if (res.status === 200) {
                    setAttendanceList(res.data)
                    if (res.data.length <= 0) {
                        setDataFound(false)
                    } else {
                        organizeCalendarData(res.data)
                    }
                    setIsFetching(false)
                }
            })
            .catch(err => {
                alert('Something went wrong!')
                setIsFetching(false)
            })
    }
    
    // Organize data into calendar weeks
    const organizeCalendarData = (data) => {
        if (!data.length) return;
        
        // Sort data by attendance date
        const sortedData = [...data].sort((a, b) => 
            parseInt(a.attendance_date) - parseInt(b.attendance_date)
        );
        
        const date = new Date(initialData.month_and_year);
        const year = date.getFullYear();
        const month = date.getMonth();
        
        // First day of month
        const firstDay = new Date(year, month, 1).getDay();
        // Convert Sunday (0) to be the last day (6) for the week that starts with Monday
        const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;
        
        // Calculate days in month
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        // Create calendar grid
        let calendar = [];
        let week = Array(7).fill(null);
        
        // Fill in the blanks before the first day
        for (let i = 0; i < adjustedFirstDay; i++) {
            week[i] = null;
        }
        
        // Fill in the days of the month
        for (let day = 1; day <= daysInMonth; day++) {
            const dayOfWeek = (adjustedFirstDay + day - 1) % 7;
            
            const attendanceForDay = sortedData.find(item => 
                parseInt(item.attendance_date) === day
            );
            
            week[dayOfWeek] = attendanceForDay || { attendance_date: day.toString(), placeholder: true };
            
            // Start a new week
            if (dayOfWeek === 6 || day === daysInMonth) {
                calendar.push([...week]);
                week = Array(7).fill(null);
            }
        }
        
        setCalendarData(calendar);
    };
    
    const updatePayment = usePut({
        url: 'updatePaymentDefination',
        refreshUrl:'getPayoutList',
        onSuccess: (data) => {
            toast.success('Payment log updated')
        },
        onError: () => { },
        onSettled: () => { }
    })

    const handleChangePaymentDefination = (e, data) => {
        let value = e.target.value
        
        const updatedList = attendanceList.map((item) => {
            if (item.attendance_date === data.attendance_date) {
                return { ...item, payment_definition: value };
            }
            return item;
        });
        
        setAttendanceList(updatedList);
        organizeCalendarData(updatedList);

        const fillData = {
            ...data,
            company_employee_id: id,
            payment_definition: value
        }

        updatePayment.handleAuth.mutate(fillData)
    }
    
    // Day names for the header
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    // Code for redeem leave day
    const { list, setGetListParams } = useGet({
        url: "settings/leave/list",
        initialData: {},
    });

    const leaveTypesOptions = list?.data?.data?.map?.((el) => {
        return {
        label: el.leave_head_name,
        value: el.leave_head_id,
        };
    });

    return (
        <>
            <Drawer anchor={'right'} open={open} onClose={onClose}>
                <div className='h-full bg-white px-8 min-h-[120vh]' style={{ width: 'calc(100vw - 250px)' }}>
                    <form className=' space-y-8'>
                        <div className='flex items-center justify-between py-5 border-b border-gray-200 sticky z-40 top-0 bg-white'>
                            <div className='flex items-center space-x-3'>
                                <ArrowLeftIcon className=' text-gray-700 w-8 h-8 cursor-pointer' onClick={onClose} />
                                <p className='text-gray-700 text-3xl font-semibold'>Salary Log for <Moment date={initialData.month_and_year} format='MMMM-YYYY' /> </p>
                            </div>
                        </div>

                        <div>
                            {isFetching ? (
                                <div className="text-center py-10">Loading...</div>
                            ) : !isDataFound ? (
                                <div className="text-center py-10">No attendance data found</div>
                            ) : (
                                <div className="calendar-container">
                                    {/* Calendar headers - Days of week */}
                                    <div className="grid grid-cols-7 gap-1 mb-2">
                                        {weekdays.map((day, index) => (
                                            <div key={index} className="text-center py-2 bg-gray-100 font-medium">
                                                {day}
                                            </div>
                                        ))}
                                    </div>
                                    
                                    {/* Calendar grid */}
                                    {calendarData.map((week, weekIdx) => (
                                        <div key={weekIdx} className="grid grid-cols-7 gap-1 mb-1">
                                            {week.map((day, dayIdx) => (
                                                <div key={dayIdx} className={`border rounded p-2 min-h-[120px] ${!day ? 'bg-gray-50' : ''}`}>
                                                    {day && (
                                                        <div className="w-full relative flex flex-col h-full">
                                                            <div className='flex items-center justify-between'>
                                                                <p className='bg-black text-white w-6 h-6 text-xs rounded-full flex items-center justify-center'>
                                                                    {day.attendance_date}
                                                                </p>
                                                                {!day.placeholder && (
                                                                    <span className={`text-xs capitalize px-2 rounded ${presentDefinition[day.present_definition] || ''}`}>
                                                                        {day.present_definition ? day.present_definition.replace(/_/g, ' ') : ''}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            
                                                            {!day.placeholder && (
                                                                <>
                                                                    <div className='py-3'>
                                                                        <small className='block'>Punch timing</small>
                                                                        <small className='font-semibold block'>{day.punch_time || 'N/A'}</small>
                                                                    </div>
                                                                    <select 
                                                                        disabled={day.present_definition === 'pending'} 
                                                                        onChange={(e) => handleChangePaymentDefination(e, day)} 
                                                                        value={day.payment_definition || ''} 
                                                                        className='w-[90%] border py-1 rounded border-gray-200 text-xs disabled:cursor-not-allowed'
                                                                    >
                                                                        {paymentDefinition?.map((list, idx) => (
                                                                            <option value={list?.value} key={idx}>
                                                                                {list?.label}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </>
                                                            )}
                                                            {["absent", "half_day"].includes(day.present_definition) && <RedeemLeaveDay
                                                                day={day}
                                                                leaveTypesOptions={leaveTypesOptions}
                                                                companyEmployeeId={id}
                                                            />}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </Drawer>
        </>
    )
}

export default PaymentLog